import React from "react";
import { Icon, Tooltip, Button, Modal } from 'antd'
import Logo from '../images/LogoV2.png';
//import SpinnerLogo from './Spinner/loading.svg';
//import SpinnerLogo from './Spinner/loadingBarraCinzaV2.svg';

import SpinnerLogoMain from './Spinner/loadingBarraVermelhoV2.svg';

export function Separador() {
  return (
    <div style={{ minHeight: 1, backgroundColor: '#e8e8e8', marginTop: 10, marginBottom: 10 }}></div>
  );
};

export function SubTitulo(props) {
  return (
    <span style={{ fontWeight: '500', display: 'inline-block', marginRight: 8, ...props.style }} >
      {props.children}
    </span>
  );
};

export function IconCheck({ ativo }) {
  return ativo ?
    <Icon type="check-circle" style={{ color: '#52c41a', fontSize: 16 }} theme="filled" />
    : <Icon type="check-circle" style={{ color: '#ddd', fontSize: 16 }} theme="filled" />
};

export function IconError({ ativo }) {
  return ativo ?
    <Icon type="close-circle" style={{ color: '#d6000b', fontSize: 16 }} theme="filled" />
    : <Icon type="close-circle" style={{ color: '#ddd', fontSize: 16 }} theme="filled" />
};

export function LoadingScreen({ loading }) {
  return (
    <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(255, 255, 255, 0.70)', zIndex: 1029, display: loading ? 'block' : 'none' }}>
      <img src={SpinnerLogoMain} alt="loading..." style={{ top: '45%', left: '50%', transform: 'translate(-50%, -50%)', position: 'absolute' }} />
    </div>
  );
};

export function LoadingScreenMain() {
  return (
    <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(255, 255, 255, 0.70)', zIndex: 1029, display: 'block' }}>
      <div style={{ top: '45%', left: '50%', transform: 'translate(-50%, -50%)', position: 'absolute', textAlign: 'center' }}>
        <div style={{ marginBottom: 20 }}><img src={Logo} style={{ maxHeight: 90 }} alt="Logo" /></div>
        <img src={SpinnerLogoMain} alt="loading..." />
      </div>
    </div>
  );
};

export function LoadingScreenSpin({ loading }) {
  return (
    <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', zIndex: 1029, display: loading ? 'block' : 'none' }}>
      <Icon type="loading" className="cor-primary" style={{ top: '45%', left: '50%', transform: 'translate(-50%, -50%)', position: 'absolute', fontSize: 40 }} />
    </div>
  );
};

export function Help({ text, iconStyles }) {
  return (
    <Tooltip placement="bottom" title={text} >
      <Icon type="question-circle" className="cor-primary" style={{ fontSize: 22, color: '#ff7400', cursor: 'help', ...iconStyles }} />
    </Tooltip>
  )
};

export function BtnConfirm(props) {

  const preConfirmacao = () => {
    Modal.confirm({
      title: 'Confirma esta operação?',
      okText: "Sim",
      cancelText: "Não",
      onOk() {
        props.onClick()
      },
    });
  }

  return (<Button type={props.type} size={props.size} ghost={props.ghost} style={props.style} disabled={props.disabled} onClick={preConfirmacao}>
    {props.children}
  </Button>)
}

export function Tag(props){
  if(!props.children){
    return null;
  }

  return <div className="divTag" {...props}><span>{props.children}</span></div>
}